import { useEffect } from 'react';
import amplitude from '../services/amplitude';

type AplitudeOpenFromLinkMetadata = {
  url: string;
  source: string;
  code: number | null;
  name: string | null;
};

export const useAmplitudeOpenFromLink = (
  metadata: AplitudeOpenFromLinkMetadata | null,
) => {
  useEffect(() => {
    if (metadata == null) return;

    const { code, name, source } = metadata;
    amplitude.openFromLink({
      url: window.location.href,
      source,
      code,
      name,
    });
  }, [metadata]);
};
